import { OfferInput } from "../types/skus"


export const getTotalValueInstallment = (offer: OfferInput) => {
  const { index, dealValue, listPrice, quantity } = offer
  const totalWithoutDiscount = listPrice * index
  const discount = listPrice - dealValue

  return (totalWithoutDiscount - discount) * quantity
}

export const getTotalValue = (offer: OfferInput) => {
  const { duration } = offer
  const total = getTotalValueInstallment(offer)

  return total * duration
}
